import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import {
  getBranches,
  getBranch,
  createBranch,
  updateBranch,
  deleteBranch,
  updateBranchPrices,
} from '../api';
import { ROUTE_URLS } from '../routes';
import { createLink, getNotifyMessage, notify } from '../utils';

export const useBranches = (options = {}) => {
  return useQuery(
    'branches',
    async () => {
      const res = await getBranches();
      return res.data;
    },
    {
      staleTime: Infinity,
      retry: false,
      ...options,
    },
  );
};

export const useBranch = id => {
  return useQuery(
    ['branch', id],
    async () => {
      const res = await getBranch(id);
      return res.data;
    },
    {
      staleTime: Infinity,
      retry: false,
    },
  );
};

export const useCreateBranch = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation(createBranch, {
    onSuccess: () => {
      notify('success', getNotifyMessage('success', 'create', 'branch'));
      queryClient.invalidateQueries();
      navigate(ROUTE_URLS.BRANCHES);
    },
    onError: () => {
      notify('error', getNotifyMessage('error', 'create', 'branch'));
    },
  });
};

export const useUpdateBranch = params => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation(updateBranch, {
    onSuccess: () => {
      notify('success', getNotifyMessage('success', 'update', 'branch'));
      queryClient.invalidateQueries();
      navigate(ROUTE_URLS.BRANCHES);
    },
    onError: () => {
      notify('error', getNotifyMessage('error', 'update', 'branch'));
    },
  });
};

export const useDeleteBranch = () => {
  const queryClient = useQueryClient();

  return useMutation(deleteBranch, {
    onSuccess: res => {
      notify('success', getNotifyMessage('success', 'delete', 'branch'));
      queryClient.invalidateQueries();
    },
    onError: res => {
      notify('error', getNotifyMessage('error', 'delete', 'branch'));
    },
  });
};

export const useUpdateBranchPrices = id => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation(updateBranchPrices, {
    onSuccess: res => {
      notify('success', getNotifyMessage('success', 'update', 'prices'));
      queryClient.invalidateQueries();
      navigate(createLink(ROUTE_URLS.BRANCH_PRICES, id));
    },
    onError: res => {
      notify('error', getNotifyMessage('error', 'update', 'prices'));
    },
  });
};
